<template>
  <div class="col-md-12 default">
    <meter-type />
  </div>
</template>

<script>
import meterType from "./MeterType.vue";

export default {
  components: {
   meterType
  },
  props: ["type"],
  data() {
    return {
      
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },

  methods: {
   
  },
};
</script>
